export const formatPatientsCount = (t, count) => `${count} ${t('stats.patients', { count })}`.trim();
